import { Close } from '@mui/icons-material';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCreateModal } from '../../../../../app/deliverables/deliverablesSlice';
import { RootState } from '../../../../../app/store';
import { createEmptyDeliverable } from '../../../../../pages/deliverables/consts';
import { useDeliverableModalContext } from '../DeliverableModalContext';
import { DeliverableModalContainer } from '../StyledComponents';
import DeliverableSummary from '../components/DeliverableSummary';
import StepperContent from '../components/StepperContent';

const AddDeliverableModal = () => {
  const { createOpenModal: modal } = useSelector(
    (state: RootState) => state.deliverables,
  );
  const { setDeliverable, setUploadedFiles } = useDeliverableModalContext();
  const { profile } = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!modal.isOpen) return;
    if (modal.cloneDeliverable) {
      setDeliverable({
        ...modal.cloneDeliverable,
        authorId: profile?.contact?.contactId,
      });
    } else if (profile?.contact?.contactId) {
      setDeliverable((prev) => ({
        ...prev,
        authorId: profile.contact.contactId,
      }));
    }
  }, [modal.isOpen, modal.cloneDeliverable, profile?.contact?.contactId]);

  const handleClose = () => {
    setDeliverable(createEmptyDeliverable());
    setUploadedFiles([]);
    dispatch(
      setCreateModal({
        isOpen: false,
      }),
    );
  };

  return (
    <Modal
      open={modal.isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <DeliverableModalContainer
        sx={{
          width: '80vw',
        }}
      >
        <Box
          sx={{
            marginBottom: 1,
            pb: 1,
            borderBottom: '2px solid var(--template-palette-divider)',
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Typography variant="h5">Create Deliverable</Typography>
          <IconButton size="small" onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            height: '100%',
            minHeight: 0,
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: 'background.paper',
              borderRight: '1px solid var(--template-palette-divider)',
              gap: 2,
              overflow: 'auto',
              width: '300px',
              height: '100%',
              p: 2.5,
            }}
          >
            <DeliverableSummary />
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              backgroundColor: 'background.default',
              overflow: 'auto',
              flex: 1,
            }}
          >
            <StepperContent />
          </Box>
        </Box>
      </DeliverableModalContainer>
    </Modal>
  );
};

export default AddDeliverableModal;
